module.exports = __webpack_public_path__ + "static/media/sb-m103.0bbb30f9.jpg";